<template>
    <div v-show="airwaysData.has_selected" id="airwaySelectedSlice" class="airway-mode-item">
        <span v-show="airwaysData.selected_slice.area" class="airway-label">Area: {{
        airwaysData.selected_slice.area }} mm<sup>2</sup></span>
        <span v-show="airwaysData.selected_slice.ap_diameter" class="airway-label">AP distance: {{
        airwaysData.selected_slice.ap_diameter }}
            mm</span>
        <span v-show="airwaysData.selected_slice.rl_diameter" class="airway-label">RL distance: {{
        airwaysData.selected_slice.rl_diameter }}
            mm</span>
        <span v-show="airwaysData.selected_slice.position_text" class="airway-label">Slice position: {{
        airwaysData.selected_slice.position_text }} mm</span>
    </div>
</template>

<script>

export default {
    name: "AirwaySelectedSlice",
    props: {
        airwaysData: {
            type: Object,
            required: true
        }
    },
    mounted() {
        // console.log("AirwayPanel mounted");
    },
};


</script>

<style scoped>
#airwaySelectedSlice {
    position: absolute;
    top: 55px;
    left: 5px;
    width: 227px;
    height: auto;

    color: white;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 500;
    /* padding: 0.2rem; */
    border: solid white 0.1rem;

    margin-bottom: 3px;
    margin-right: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.airway-label {
    font-size: 13px;
    border: 0;
    display: inline-block;
}
</style>